declare global {
  interface Window {
    hubspot_web_interactives_running?: boolean;
    _hsp?: unknown[];
  }
}

export const showHubSpotCookieBanner = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  window._hsp = window._hsp || [];
  window._hsp.push(['showBanner']);
};

const HUBSPOT_SCRIPT_ID = 'hs-web-interactives-loader';
const HUBSPOT_ELEMENT_IDS = [
  HUBSPOT_SCRIPT_ID,
  'hs-web-interactives-top-anchor',
  'hs-web-interactives-top-push-anchor',
  'hs-web-interactives-bottom-anchor',
  'hs-web-interactives-floating-container',
];

export const initializeHubspotWebInteractives = (): void => {
  if (typeof document === 'undefined' || !document.body) {
    return;
  }

  HUBSPOT_ELEMENT_IDS.forEach((elementId) => {
    const existingElement = document.getElementById(elementId);
    if (existingElement) {
      existingElement.remove();
    }
  });

  if (typeof window !== 'undefined') {
    window.hubspot_web_interactives_running = false;
  }

  const script = document.createElement('script');
  script.id = HUBSPOT_SCRIPT_ID;
  script.src = 'https://js.hubspot.com/web-interactives-embed.js';
  script.async = true;
  document.body.appendChild(script);
};
